export class Environment {
  static getApplicationVersion() {
    return process.env.REACT_APP_VERSION;
  }

  static getPublicUrl() {
    return process.env.PUBLIC_URL;
  }

  static getNodeEnvironment() {
    return process.env.NODE_ENV;
  }

  static getSvHarborLogoutUrl() {
    return process.env.REACT_APP_SV_HARBOR_LOGOUT;
  }

  static getSupervaluLogoutUrl() {
    return process.env.REACT_APP_SUPERVALU_LOGOUT;
  }

  static getMyUNFILogoutUrl() {
    return process.env.REACT_APP_MYUNFI_LOGOUT;
  }

  static getCrispLogoutUrl() {
    return process.env.REACT_APP_CRISP_LOGOUT;
  }

  static getOidcLogoutUrl() {
    return process.env.REACT_APP_OIDC_LOGOUT;
  }

  static getPostLogoutRedirect() {
    return process.env.REACT_APP_POST_LOGOUT_REDIRECT;
  }

  static getLogoutUrls() {
    return [
      this.getSvHarborLogoutUrl(),
      this.getSupervaluLogoutUrl(),
      this.getMyUNFILogoutUrl(),
      this.getCrispLogoutUrl(),
      this.getOidcLogoutUrl(),
    ];
  }

  static getMyUnfiHomeUrl() {
    return process.env.REACT_APP_MYUNFI_HOME;
  }

  static getSvHarborHomeUrl() {
    return process.env.REACT_APP_SVHARBOR_HOME;
  }

  static getElasticServiceName() {
    return process.env.REACT_APP_ELASTIC_SERVICE_NAME;
  }

  static getElasticServerUrl() {
    return process.env.REACT_APP_ELASTIC_SERVER_URL;
  }

  static getElasticServiceVersion() {
    return process.env.REACT_APP_ELASTIC_SERVICE_VERSION;
  }

  static getElasticEnvironment() {
    return process.env.REACT_APP_ELASTIC_ENVIRONMENT;
  }

  static getElasticEnabled() {
    return process.env.REACT_APP_ELASTIC_ENABLED === 'true';
  }
}
